<template>
  <div class="homework-detail">
    <div class="header" :class="{ 'have-remark': !!classTaskDetail.remark }">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'homeworkList' }">{{ $t('homeworkManage.jobManagement') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('jobManagementV2.myHomework') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail">
        <!-- <div class="title"><span>{{classTaskDetail.projectName}}</span></div> -->
        <div class="detail-right">
          <div class="homework-name">
            <el-tooltip effect="dark" popper-class="task-name-tooltip"
              :disabled="classTaskDetail.projectName && classTaskDetail.projectName.length <= 26"
              :content="classTaskDetail.projectName" placement="top">
              <span class="name">{{ classTaskDetail.projectName | textHiddenTail(26) }}</span>
            </el-tooltip>
            <span :class="`homework-status status-${statusFormat(classTaskDetail, 1)}`">{{ statusFormat(classTaskDetail,
              2) }}</span>

          </div>
          <div class="homework-info-box">
            <!-- 第一层 -->
            <div class="homework-info-first">
              <!-- 语言方向 -->
              <div class="homework-info-item">
                {{ $t('newProjectV2.langPair') }}：
                <span>
                  <template v-if="$i18n.locale === 'zh' && classTaskDetail.langDesc">{{
                    classTaskDetail.langDesc.replace('>',
                      ' — ') }}</template>
                  <template v-else>{{ $langCase[classTaskDetail.sourceLang] }} —
                    {{ $langCase[classTaskDetail.targetLang] }}</template>
                </span>
              </div>
              <!-- 领域 -->
              <div class="homework-info-item">{{ $t('newProjectV2.domain') }}：<span>{{ $i18n.locale === 'zh' ?
                classTaskDetail.domainName :
                $domainCase[classTaskDetail.domainCode] }}</span></div>
              <!-- 创建时间 -->
              <div class="homework-info-item">{{ $t('common.creationTime') }}：<span>{{ classTaskDetail.createTime
              }}</span></div>
              <!-- 截至时间 -->
              <div class="homework-info-item">{{ $t('newProjectV2.limitTime') }}：<span>{{ classTaskDetail.limitTime
              }}</span></div>
              <!-- 机器翻译 -->
              <div class="homework-info-item">{{ $t('newProjectV2.machineTrans') }}：<span
                  :class="`pre-mt-${classTaskDetail.isPreMt}`">{{
                    classTaskDetail.isPreMt === 1 ?
                    $t('homeworkManage.enabled') : $t('homeworkManage.disabled') }}</span></div>
            </div>
            <div class="homework-info-second">
              <!-- 文件 -->
              <div class="homework-info-item">
                <span class="item-title">
                  {{ $t('project.file') }}：
                </span>
                <span class="item-file-name">
                  {{ classTaskDetail.name }}
                </span>
                <div class="preview-file"><span class="preview" @click="handlePreview">{{ $t('projectDetailsV2.preview')
                }}<i class="el-icon-arrow-right"></i></span></div>
                <!-- 重新上传 -->
                <el-button class="btn-reupload" @click="handleReUpload" size="mini" type="info"
                  v-if="statusFormat(classTaskDetail, 1) === 1">重新上传</el-button>
              </div>
            </div>
            <!-- <li>{{$t('projectDetailsV2.file')}}：<span>{{classTaskDetail.name}}</span><span class="preview" @click="handlePreview">{{$t('projectDetailsV2.preview')}}<i class="el-icon-arrow-right"></i></span></li> -->
            <div class="remark">
              {{ $t('newProjectV2.remark') }}：<span>{{ classTaskDetail.remark || '--' }}</span></div>
          </div>
        </div>
      </div>
      <!-- 操作栏 -->
      <div class="header-action">
        <!-- 编辑 -->
        <div class="header-edit" @click="handleEditor">{{ $t('newProjectV2.edit') }}</div>
        <!-- 设置 -->
        <div class="header-setting" @click="handleSetting">{{ $t('projectDetailsV2.setting') }}</div>
        <!-- 分配 -->
        <div class="header-assign" @click="handleAssign" v-if="statusFormat(classTaskDetail, 1) === 1">
          {{ $t('projectDetailsV2.distribution') }}</div>
        <!-- 取消分配 -->
        <div class="header-cancel" @click="handleCancel" v-if="statusFormat(classTaskDetail, 1) === 2">
          {{ $t('homeworkManage.cancelJob') }}</div>
        <!-- 下载报告 -->
        <div class="header-download" @click="handleDownload" v-if="statusFormat(classTaskDetail, 1) === 3">
          {{ $t('jobManagementV2.downloadReport') }}</div>
        <!-- 删除 -->
        <div class="header-delete" @click="handleDelete">{{ $t('common.del') }}</div>
      </div>
    </div>
    <div class="class-content" :class="{ 'have-remark': !!classTaskDetail.remark }" v-if="classList.length > 0">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in classList" :key="item.id" :name="String(item.id)" :label="item.name"></el-tab-pane>
      </el-tabs>
      <div class="table">
        <class-table :activeClassId="Number(activeName)" :classTaskDetail="classTaskDetail"></class-table>
      </div>
    </div>
    <div class="class-content empty-content" :class="{ 'have-remark': !!classTaskDetail.remark }" v-else>
      <span>{{ $t('homeworkManage.pleaseAllocateJob') }}</span>
    </div>
    <assign-homework ref="assignHomework" :dialogVisible="assignVisible" @handleClose="handleAssignClose" @update="init" @addClass="addClass"
      :globalObj="{ id: this.queryData.id }"></assign-homework>
    <preview-file :classTaskDetail="classTaskDetail" :queryData="classTaskDetail" :dialogVisible="previewVisible"
      @handleClose="handlePreviewClose"></preview-file>
    <base-dialog :dialogVisible="deleteVisible" @handleConfirm="handleDeleteConfirm" @handleClose="handleDeleteClose">
      <div class="delete-content">{{ $t('jobManagementV2.deleteOperation') }}</div>
    </base-dialog>
    <base-dialog :dialogVisible="cancelVisible" @handleConfirm="handleCancelConfirm" @handleClose="handleCancelClose">
      <div class="delete-content">{{ $t('homeworkManage.cancelOperation') }}</div>
    </base-dialog>
    <async-download-file :isDownloadLoading="isDownloadLoading" :asyncDownloadFun="asyncDownloadFun"
      @handleClose="handleDownloadClose"></async-download-file>
    <!-- 编辑项目 -->
    <EditProject :visible="editProjectVisible" :editProject="editProjectInfo" @handleCancel="editProjectCancel"
      @updateProjectInfo="updateProjectInfo">
    </EditProject>
    <!-- 重新上传 -->
    <ReUploadFile :updateFileInfo="updateFileInfo" :updateFileVisible="updateFileVisible"
      @uploadFileCancel="uploadFileCancel" @uploadFileConfirm="uploadFileConfirm"></ReUploadFile>
        <!-- 添加班级 -->
    <addclass-dialog
      :addclassVisible="addclassVisible"
      @handlerclassClose="handlerclassClose"
      @handlerclassSuccess="handlerclassSuccess"
    >
    </addclass-dialog>
    <!-- 新的分配作业 -->
    <NewAssignHomework
      :globalObj="{ id: this.queryData.id }"
      :assignHomeworkVisible="assignHomeworkVisible"
      @handleAssignClose="handleAssignClose"
      @update="init"
    >
    </NewAssignHomework>
  </div>
</template>

<script>
import BaseDialog from '@/components/delDialog';
import ClassTable from './components/class-table';
import PreviewFile from './components/preview-file';
import AssignHomework from '../homework-list/components/assign-homework';
import addclassDialog from "../homework-list/components/addclassDialog/addClassDialog.vue";
import AsyncDownloadFile from '@/components/async-download-file';
import EditProject from '@/components/projectDialog/editProject';
import ReUploadFile from './components/reupload'
import NewAssignHomework from "../homework-list/components/new-assign-homework/index.vue";

import { deleteProject } from "@/services/myProjectApi";
import { cancelJob, queryClassByFile, queryClassTaskDetail, downloadHomeworkReport } from '@/services/jobManagement';

export default {
  name: 'HomeworkDetail',
  components: {
    BaseDialog,
    ClassTable,
    PreviewFile,
    AssignHomework,
    AsyncDownloadFile,
    EditProject,
    ReUploadFile,
    addclassDialog,
    NewAssignHomework
  },
  data() {
    return {
      queryData: {},
      activeName: '', // 选中的班级
      previewVisible: false,
      classList: [],
      deleteVisible: false,
      classTaskDetail: {}, // 详情
      isDownloadLoading: false, // 下载
      asyncDownloadFun: () => { }, // 下载方法
      cancelVisible: false, // 取消作业
      assignVisible: false, // 分配
      editProjectVisible: false, // 编辑
      editProjectInfo: {},
      updateFileVisible: false,
      updateFileInfo: {},
      addclassVisible: false,
      assignHomeworkVisible:false,

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    };
  },
  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
  },
  async mounted() {
    // await this.getClassList();
    // if (this.classList.length > 0) {
    //   this.activeName = String(this.classList[0].id);
    // }
    this.init();
  },
  methods: {
    async init() {
      // console.log(this.activeName);
      this.activeName = ""
      this.getClassTaskDetail();
      await this.getClassList();
      if (this.classList.length > 0) {
        this.activeName = String(this.classList[0].id);
      }
    },
    async getClassList() {
      let { success, result } = await queryClassByFile({
        fileId: this.queryData.id,
        companyCode: this.companyCode,
      });
      if (success) {
        this.classList = result;
      }
    },
    //重新上传
    handleReUpload() {
      this.updateFileInfo = {
        id: this.classTaskDetail.id
      }
      this.updateFileVisible = true
    },
    uploadFileCancel() {
      this.updateFileVisible = false
    },
    uploadFileConfirm() {
      // this.updateFileVisible = false
      this.init()
    },
    //编辑
    handleEditor() {
      this.editProjectInfo = {
        id: this.classTaskDetail.projectId,
        name: this.classTaskDetail.projectName,
        deliveryTime: this.classTaskDetail.limitTime,
        remark: this.classTaskDetail.remark
      };
      this.editProjectVisible = true;
    },
    editProjectCancel() {
      this.editProjectVisible = false;
    },
    updateProjectInfo() {
      this.getClassTaskDetail()
    },
    //设置
    handleSetting() {
      this.$router.push({
        name: 'DetailSetting',
        query: { id: this.classTaskDetail.projectId, type: 'homework', uid: this.classTaskDetail.id }
      })
    },
    handlePreview() {
      this.previewVisible = true;
    },
    handlePreviewClose() {
      this.previewVisible = false;
    },
    statusFormat(row, type) {
      let total = row.unFinishTaskNumber + row.finishTaskNumber;
      if (total === 0) {
        return type === 1 ? 1 : this.$t('assignTaskV2.notAssign');
      } else {
        if (row.finishTaskNumber === total) {
          return type === 1 ? 3 : this.$t('assignTaskV2.complete');
        }
        return type === 1 ? 2 : this.$t('assignTaskV2.haveAssign');
      }
    },
    handleAssign() {
      this.assignHomeworkVisible = true;
    },
    handleAssignClose() {
      this.assignHomeworkVisible = false;
    },
    handleCancel() {
      this.cancelVisible = true;
    },
    async handleCancelConfirm() {
      let { success } = await cancelJob({
        fileId: this.classTaskDetail.id,
        projectId: this.classTaskDetail.projectId,
        companyCode: this.companyCode,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('homeworkManage.cancelSuccessful'));
        this.handleCancelClose();
        this.init();
      }
    },
    handleCancelClose() {
      this.cancelVisible = false;
    },
    handleDownload() {
      this.asyncDownloadFun = () => downloadHomeworkReport({
        projectId: this.classTaskDetail.projectId,
        companyCode: this.companyCode,
      });
      this.isDownloadLoading = true;
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => { };
      this.isDownloadLoading = false;
    },
    handleDelete() {
      this.deleteVisible = true;
    },
    async handleDeleteConfirm() {
      let { success } = await deleteProject({
        id: this.classTaskDetail.projectId,
        companyCode: this.companyCode,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('newProjectV2.delSuccess'));
        this.handleDeleteClose();
        this.$router.push({ name: 'homeworkList' });
      }
    },
    handleDeleteClose() {
      this.deleteVisible = false;
    },
    async getClassTaskDetail() {
      let { success, result } = await queryClassTaskDetail({
        id: this.queryData.id,
        companyCode: this.companyCode,
      });
      if (success) {
        this.classTaskDetail = result;
      }
    },
     //添加班级
     addClass() {
      this.addclassVisible = true;
    },
    //关闭添加班级
    handlerclassClose() {
      this.addclassVisible = false;
    },
    //添加班级成功
    handlerclassSuccess() {
      this.addclassVisible = false;
      //更新班级列表
      this.$refs.assignHomework.getClassList()
    },
  },
}
</script>

<style lang="less" scoped>@import "./style/index.less";</style>